export default __webpack_public_path__ + "static/media/Mobile-08.3a6b8f56.jpg";